import './ConsumerHomepageHero.scss';
import ConsumerHomepageHero from './ConsumerHomepageHero.vue';
import { createApp } from 'vue';

const ConsumerHomepageHeroElems = document.querySelectorAll(
	'[data-feature="consumer-homepage-hero"]'
);

if (ConsumerHomepageHeroElems) {
	ConsumerHomepageHeroElems.forEach((elem) => {
		const app = createApp({
			name: 'ConsumerHomepageHeroApp',
		});
		app.component('consumer-homepage-hero', ConsumerHomepageHero);
		app.mount(elem);
	});
}
